
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/react-button-group",
      function () {
        return require("private-next-pages/joy-ui/react-button-group.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/react-button-group"])
      });
    }
  